var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RouteAlive',{ref:"routeAlive",attrs:{"current":_vm.current,"include":_vm.includeRoute},on:{"destroyed":_vm.handleDestroyed,"removed":_vm.handleRemoved}})
}
var staticRenderFns = []

export { render, staticRenderFns }